(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[927],{

/***/ 4044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTimeout; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _useMounted__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6454);
/* harmony import */ var _useWillUnmount__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6852);



/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */

var MAX_DELAY_MS = Math.pow(2, 31) - 1;

function setChainedTimeout(handleRef, fn, timeoutAtMs) {
  var delayMs = timeoutAtMs - Date.now();
  handleRef.current = delayMs <= MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(function () {
    return setChainedTimeout(handleRef, fn, timeoutAtMs);
  }, MAX_DELAY_MS);
}
/**
 * Returns a controller object for setting a timeout that is properly cleaned up
 * once the component unmounts. New timeouts cancel and replace existing ones.
 *
 *
 *
 * ```tsx
 * const { set, clear } = useTimeout();
 * const [hello, showHello] = useState(false);
 * //Display hello after 5 seconds
 * set(() => showHello(true), 5000);
 * return (
 *   <div className="App">
 *     {hello ? <h3>Hello</h3> : null}
 *   </div>
 * );
 * ```
 */


function useTimeout() {
  var isMounted = (0,_useMounted__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(); // types are confused between node and web here IDK

  var handleRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  (0,_useWillUnmount__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function () {
    return clearTimeout(handleRef.current);
  });
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var clear = function clear() {
      return clearTimeout(handleRef.current);
    };

    function set(fn, delayMs) {
      if (delayMs === void 0) {
        delayMs = 0;
      }

      if (!isMounted()) return;
      clear();

      if (delayMs <= MAX_DELAY_MS) {
        // For simplicity, if the timeout is short, just set a normal timeout.
        handleRef.current = setTimeout(fn, delayMs);
      } else {
        setChainedTimeout(handleRef, fn, Date.now() + delayMs);
      }
    }

    return {
      set: set,
      clear: clear
    };
  }, []);
}

/***/ }),

/***/ 942:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/professional-services",
      function () {
        return __webpack_require__(7244);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 699:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/default-splash-card.0ded0b20.png","height":1667,"width":1667,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAqElEQVR42iWOOQrCABBF5wiC4lKIW+GWmEWSVo8QUAhoE21SBtLmDIE0aXOAtDmC1mlyn4cZhAczzPzP/4JhYjs4Lu5Zl5OFeeoRHZMZgyEizBcslmx3/Vs4GjyevN4kCbc7QcDlym4veD5VRdPQddQ1aUoUsVqLGsNQhWVJ2/L5kueIiKatN4iQZRSFXuOY0Vi0lWVrq/0BEWU8xXa01R+1en6PigzzB2D/YcmSCI2wAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 7333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AccordionComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1555);
/* harmony import */ var react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5607);
/* harmony import */ var _atk_hooks_framerMotion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(658);
/* harmony import */ var _Accordion_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6237);
/* harmony import */ var _Accordion_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_2__);





function AccordionComponent(param) {
    let { sectionTitle , customClass , items , alwaysOpen , colDesc  } = param;
    const componentClass = "AccordionComponent ".concat((_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_2___default().AccordionComponent), " ").concat(customClass !== null && customClass !== void 0 ? customClass : "");
    var _desc;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: componentClass,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "mb-5",
                dangerouslySetInnerHTML: {
                    __html: sectionTitle !== null && sectionTitle !== void 0 ? sectionTitle : ""
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                alwaysOpen: alwaysOpen,
                children: items === null || items === void 0 ? void 0 : items.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atk_hooks_framerMotion__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Item */ .Z.Item, {
                            eventKey: index.toString(),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Header */ .Z.Header, {
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Body */ .Z.Body, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        lg: colDesc !== null && colDesc !== void 0 ? colDesc : 10,
                                        dangerouslySetInnerHTML: {
                                            __html: (_desc = item.desc) !== null && _desc !== void 0 ? _desc : ""
                                        }
                                    })
                                })
                            ]
                        })
                    }, index))
            })
        ]
    });
}


/***/ }),

/***/ 8395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CTARight; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4051);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1555);
/* harmony import */ var react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5005);
/* harmony import */ var _atk_hooks_framerMotion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(658);
/* harmony import */ var _CTARight_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2113);
/* harmony import */ var _CTARight_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_CTARight_module_scss__WEBPACK_IMPORTED_MODULE_2__);





function CTARight(param) {
    let { id , halfTitle , title , desc , customClass , linkButton , col1 , col2 , yFrameMotion  } = param;
    const componentClass = "ctaRight ".concat((_CTARight_module_scss__WEBPACK_IMPORTED_MODULE_2___default().ctaRight), "  ").concat(customClass !== null && customClass !== void 0 ? customClass : "");
    var _target;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        id: id,
        className: componentClass,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atk_hooks_framerMotion__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                y: yFrameMotion,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: "align-items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            md: col1 ? col1 : 6,
                            children: [
                                halfTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "half-title",
                                    children: halfTitle
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "h3 mb-4 mb-lg-0",
                                    children: title
                                }),
                                desc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: desc
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            className: "d-flex justify-content-end",
                            md: col2 ? col2 : 6,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                variant: linkButton.variant,
                                target: (_target = linkButton.target) !== null && _target !== void 0 ? _target : "_self",
                                ...typeof linkButton.link === "string" ? {
                                    href: linkButton.link
                                } : {
                                    onClick: linkButton.link
                                },
                                children: linkButton.label
                            })
                        })
                    ]
                })
            })
        })
    });
}


/***/ }),

/***/ 3065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomHead; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _assets_img_default_splash_card_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(699);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);





const baseUrl = "https://www.casperlabs.io/";
const siteName = "Casper Labs";
function CustomHead(param) {
    let { title , description ="" , og , twitter , business , children  } = param;
    if (!og) {
        og = {
            ogTitle: title,
            ogDescription: description,
            ogImage: _assets_img_default_splash_card_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src
        };
    }
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const key = (0,react__WEBPACK_IMPORTED_MODULE_4__.useId)();
    const ogUrl = "".concat(baseUrl.substring(0, baseUrl.length - 1)).concat(router.asPath);
    return(// eslint-disable-next-line @next/next/no-script-component-in-head
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/x-icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "192x192",
                href: "/android-chrome-192x192.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "512x512",
                href: "/android-chrome-512x512.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preload",
                href: "".concat(baseUrl, "icons/navbar-toggle-icon.webp"),
                as: "image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                content: "Casper Labs"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "googlebot",
                content: "all"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "bingbot",
                content: "all"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "all"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "facebook-domain-verification",
                content: "5dpoinx6gwzawxktv7aakmzim1f23c"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: siteName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: "1200"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: "630"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: og.ogTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: og.ogDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: ogUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: og.ogImage
            }),
            twitter && Object.keys(twitter).map((p)=>{
                const content = twitter[p];
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:".concat(p),
                    content: content
                }, key + p);
            }),
            business && Object.keys(business).map((p)=>{
                const content = business[p];
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "business:contact_data:".concat(p),
                    content: content
                }, key + p);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: ogUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "manifest",
                href: "/manifest.json"
            }),
            children
        ]
    }));
}


/***/ }),

/***/ 4516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Hero; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1555);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4051);
/* harmony import */ var react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5005);
/* harmony import */ var _Hero_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5380);
/* harmony import */ var _Hero_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Hero_module_scss__WEBPACK_IMPORTED_MODULE_2__);






function Hero(param) {
    let { halfTitle , title , desc , bgImage , linkButton , linkButton2 , customClass , col1 , col2 , colLg1 , colLg2 , children , childrenCol , isHeader  } = param;
    const componentClass = "Hero position-relative ".concat(customClass !== null && customClass !== void 0 ? customClass : "");
    const childrenContentClass = "childrenContent ".concat((_Hero_module_scss__WEBPACK_IMPORTED_MODULE_2___default().childrenContent));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: componentClass,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            className: "align-items-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: "content",
                    md: col1,
                    lg: colLg1,
                    children: [
                        halfTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "half-title",
                            children: halfTitle
                        }),
                        isHeader ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "header-section-title mb-4",
                            dangerouslySetInnerHTML: {
                                __html: title !== null && title !== void 0 ? title : ""
                            }
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "header-section-title section-title-h2 mb-4",
                            dangerouslySetInnerHTML: {
                                __html: title !== null && title !== void 0 ? title : ""
                            }
                        }),
                        desc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mb-4",
                            children: desc
                        }),
                        childrenCol && childrenCol === 1 && children,
                        linkButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: linkButton.link,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                className: linkButton2 && "me-4 mb-4 mb-lg-0",
                                variant: linkButton.variant,
                                children: linkButton.label
                            })
                        }),
                        linkButton2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: linkButton2.link,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                variant: linkButton2.variant,
                                children: linkButton2.label
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    style: {
                        backgroundImage: bgImage ? 'url("'.concat(bgImage, '")') : "none"
                    },
                    className: childrenContentClass,
                    md: col2,
                    lg: colLg2,
                    children: (!childrenCol || childrenCol === 2) && children
                })
            ]
        })
    });
}


/***/ }),

/***/ 5039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HotspotModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6212);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4051);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5015);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _atk_components_loaders_ListLoader_ListLoader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1608);
/* harmony import */ var _atk_hooks_useHotspotForm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7602);
/* harmony import */ var _HotspotModal_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6025);
/* harmony import */ var _HotspotModal_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_HotspotModal_module_scss__WEBPACK_IMPORTED_MODULE_9__);







function HotspotModal(param) {
    let { formId , target , showModal , handleClose , children  } = param;
    const { loading , initHotspotForm  } = (0,_atk_hooks_useHotspotForm__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        region: "na1",
        portalId: "6073987",
        formId,
        target
    });
    const [showToast, setShowToast] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)(()=>{
        if (showModal) {
            const timerHubspot = setTimeout(()=>{
                initHotspotForm();
            }, 100);
            const timer = setTimeout(()=>{
                const el = document.getElementById(target.replace("#", ""));
                if (el && !el.hasChildNodes()) {
                    handleClose();
                    setShowToast(true);
                }
            }, 10000);
            return ()=>{
                clearTimeout(timerHubspot);
                clearTimeout(timer);
            };
        }
    //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        showModal
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                centered: true,
                className: "custom-modal",
                show: showModal,
                onHide: handleClose,
                fullscreen: true,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Header */ .Z.Header, {
                        closeButton: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Body */ .Z.Body, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            className: "modal-container",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                className: "justify-content-center",
                                children: [
                                    loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atk_components_loaders_ListLoader_ListLoader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "formContainer",
                                        children: children
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                className: (_HotspotModal_module_scss__WEBPACK_IMPORTED_MODULE_9___default().toast),
                onClose: ()=>setShowToast(false),
                show: showToast,
                delay: 5000,
                autohide: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Body */ .Z.Body, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "Sorry, this form is no longer available."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                children: [
                                    "You can request this content through our",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        href: "/contact?section=contactForm",
                                        children: " Contact Us"
                                    }),
                                    " page."
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 1608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ListLoader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4051);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1555);
/* harmony import */ var react_bootstrap_Spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6968);
/* harmony import */ var _ListLoader_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5973);
/* harmony import */ var _ListLoader_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ListLoader_module_scss__WEBPACK_IMPORTED_MODULE_1__);




function ListLoader() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_ListLoader_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loaderContainer),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            className: "mt-5",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                md: "auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Spinner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: "text-green",
                    animation: "border",
                    role: "status",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "visually-hidden",
                        children: "Loading..."
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 7654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Newsletter2; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(4051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/@shared/components/loaders/ListLoader/ListLoader.tsx
var ListLoader = __webpack_require__(1608);
// EXTERNAL MODULE: ./src/@shared/hooks/useHotspotForm.ts
var useHotspotForm = __webpack_require__(7602);
;// CONCATENATED MODULE: ./src/@shared/components/layout/Modal/HubspotForm.tsx




function HubspotForm(param) {
    let { formId , target , children , onFormSubmitted  } = param;
    const { loading , initHotspotForm , show  } = (0,useHotspotForm/* default */.Z)({
        region: "na1",
        portalId: "6073987",
        formId,
        target,
        autohide: true
    });
    (0,react.useEffect)(()=>{
        const timerHubspot = setTimeout(()=>{
            initHotspotForm();
        }, 1000);
        return ()=>{
            clearTimeout(timerHubspot);
        };
    }, []);
    (0,react.useEffect)(()=>{
        if (onFormSubmitted) onFormSubmitted(show);
    }, [
        onFormSubmitted,
        show
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLoader/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "formContainer",
                children: children
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/@shared/hooks/framerMotion.tsx
var framerMotion = __webpack_require__(658);
// EXTERNAL MODULE: ./src/@shared/components/newsletter/Newsletter2/Newsletter2.module.scss
var Newsletter2_module = __webpack_require__(8877);
var Newsletter2_module_default = /*#__PURE__*/__webpack_require__.n(Newsletter2_module);
;// CONCATENATED MODULE: ./src/@shared/components/newsletter/Newsletter2/Newsletter2.tsx






function Newsletter2(param) {
    let { title , desc , col1 , col2 , customClass  } = param;
    const componentClass = "newsLetter2 ".concat((Newsletter2_module_default()).newsLetter2, " ").concat(customClass !== null && customClass !== void 0 ? customClass : "");
    const [submitted, setSubmitted] = (0,react.useState)(false);
    const onFormSubmitted = (value)=>{
        setSubmitted(value !== null && value !== void 0 ? value : false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: componentClass,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
            y: 100,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    className: "align-items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            md: col1 ? col1 : 6,
                            className: (Newsletter2_module_default()).title,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "h3 mb-4 mb-lg-0",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb-4 mb-lg-0",
                                    children: desc
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            md: col2 ? col2 : 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "position-relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HubspotForm, {
                                    formId: "1f65e0fe-b2be-4ee0-986d-ac8f8821f529",
                                    target: "#getCTANewsletterHubspot",
                                    onFormSubmitted: onFormSubmitted,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            id: "getCTANewsletterHubspot"
                                        }),
                                        !submitted && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "inputArrow",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                width: "12",
                                                height: "11",
                                                viewBox: "0 0 10 8",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M0.997559 4.00021H9.00205M9.00205 4.00021L5.8578 0.855957M9.00205 4.00021L5.8578 7.14447",
                                                        stroke: "#fff"
                                                    }),
                                                    " "
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
}


/***/ }),

/***/ 658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FramerMotion; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3838);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



function FramerMotion(param) {
    let { children , animation ="fadeUp" , y  } = param;
    const [isMobile, setIsMobile] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setIsMobile(window.innerWidth <= 768);
        const handleResize = ()=>{
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    if (isMobile) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: children
    });
    const fadeInProps = {
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        exit: {
            opacity: 0
        }
    };
    const fadeUpProps = {
        initial: {
            opacity: 0,
            y: y && y || 250
        },
        whileInView: {
            opacity: 1,
            y: 0
        },
        transition: {
            type: "spring",
            stiffness: 50,
            duration: 2
        },
        viewport: {
            once: true
        },
        className: "framerMotion"
    };
    const animationProps = animation === "fadeIn" ? fadeInProps : fadeUpProps;
    const { ...motionProps } = animationProps;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
        ...motionProps,
        children: children
    });
}


/***/ }),

/***/ 7602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useHotspotForm; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

const reducer = (currentState, newState)=>{
    return {
        ...currentState,
        ...newState
    };
};
function useHotspotForm(param) {
    let { region , portalId , formId , target , autohide  } = param;
    const initialState = {
        loading: true,
        show: false
    };
    const [{ loading , show  }, setState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(reducer, initialState);
    const toggleShow = ()=>setState({
            show: !show
        });
    const noShow = ()=>{
        setState({
            show: false
        });
        initHotspotForm();
    };
    const initHotspotForm = ()=>{
        hbspt.forms.create({
            region,
            portalId,
            formId,
            target,
            onFormReady: ()=>{
                setState({
                    loading: false
                });
            },
            onBeforeFormInit: (ctx)=>{
                if (ctx.pageUrl) {
                    setState({
                        loading: false
                    });
                }
            },
            onFormSubmitted: function() {
                setState({
                    show: true
                });
                if (autohide) {
                    const timerHubspot = setTimeout(()=>{
                        noShow();
                    }, 5000);
                    return ()=>{
                        clearTimeout(timerHubspot);
                    };
                }
            }
        });
    };
    return {
        loading,
        show,
        toggleShow,
        noShow,
        initHotspotForm
    };
}


/***/ }),

/***/ 7244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Services; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
;// CONCATENATED MODULE: ./src/assets/img/services-hero.webp
/* harmony default export */ var services_hero = ({"src":"/_next/static/media/services-hero.96047b07.webp","height":803,"width":846,"blurDataURL":"data:image/webp;base64,UklGRloAAABXRUJQVlA4IE4AAADwAQCdASoIAAgAAkA4JYwCdAEPAP9+XgAA/vin5KlIU6RvDLyx+yFfqpQsAaPvGqZYf01TG54P1YUgG+iCoAwGDBYNSsANZiy/zc+YoAA=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/assets/img/power-of-blockchain.webp
/* harmony default export */ var power_of_blockchain = ({"src":"/_next/static/media/power-of-blockchain.2b4162a5.webp","height":714,"width":845,"blurDataURL":"data:image/webp;base64,UklGRogAAABXRUJQVlA4IHwAAAAwAgCdASoIAAcAAkA4JbACdGuAdIwCz3MI8AD9ApkJksV4/sroyT+PWtgX5q0Tj8mLBUJzd33268IsQBewgD3rIbmdCTBc9lcL+JR4ddVUP6Bf3/4NqG9i+v/yb/n7//EXn/Ds0nX+jLi3/QfP/BFb/o3//5Fg97I/4BgA","blurWidth":8,"blurHeight":7});
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(4051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./src/modules/professional-services/components/BlockchainEra/BlockchainEra.module.scss
var BlockchainEra_module = __webpack_require__(3253);
var BlockchainEra_module_default = /*#__PURE__*/__webpack_require__.n(BlockchainEra_module);
;// CONCATENATED MODULE: ./src/modules/professional-services/components/BlockchainEra/BlockchainEra.tsx



function BlockchainEra() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (BlockchainEra_module_default()).BlockchainEra,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                children: [
                    "The ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-green",
                        children: "Blockchain"
                    }),
                    " era is here"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                className: (BlockchainEra_module_default()).hr
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                className: "mb-5 mb-lg-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        lg: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Blockchain technology is just entering its prime and has already unlocked remarkable business value: 93% of global executives believe that blockchain unlocks significant new revenue potential, and 83% report that blockchain initiatives are already underway at their organization."
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        lg: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "We take an active role in your software development process. Our consulting services educate, explore and unlock every potential use case for the Casper Blockchain - from data security to automation, smart contracts to IoT, and more."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                        className: "mb-lg-0",
                        md: 5,
                        lg: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: (BlockchainEra_module_default()).h1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-green",
                                    children: " 93 %"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "of global executives believe that blockchain unlocks significant new revenue potential."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        className: "d-flex justify-content-center",
                        md: 2,
                        lg: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (BlockchainEra_module_default()).vl
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                        md: 5,
                        lg: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: (BlockchainEra_module_default()).h1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-purple",
                                    children: " 83 %"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "report that blockchain initiatives are already underway at their organization."
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(8182);
// EXTERNAL MODULE: ./node_modules/react-multi-carousel/index.js
var react_multi_carousel = __webpack_require__(6529);
;// CONCATENATED MODULE: ./src/assets/icons/discovery.svg
/* harmony default export */ var discovery = ({"src":"/_next/static/media/discovery.587b6348.svg","height":79,"width":61});
;// CONCATENATED MODULE: ./src/assets/icons/iniciatives.svg
/* harmony default export */ var iniciatives = ({"src":"/_next/static/media/iniciatives.802343d7.svg","height":93,"width":108});
;// CONCATENATED MODULE: ./src/assets/icons/training.svg
/* harmony default export */ var training = ({"src":"/_next/static/media/training.f2be122a.svg","height":93,"width":88});
;// CONCATENATED MODULE: ./src/assets/icons/adapt.svg
/* harmony default export */ var adapt = ({"src":"/_next/static/media/adapt.cd285749.svg","height":92,"width":108});
;// CONCATENATED MODULE: ./src/assets/icons/managed-services.svg
/* harmony default export */ var managed_services = ({"src":"/_next/static/media/managed-services.9ffe46c9.svg","height":92,"width":108});
// EXTERNAL MODULE: ./src/@shared/functions/format.ts
var format = __webpack_require__(7814);
// EXTERNAL MODULE: ./src/@shared/components/icon/index.tsx + 3 modules
var icon = __webpack_require__(8068);
// EXTERNAL MODULE: ./src/modules/professional-services/components/SlideOffer/SlideOffer.module.scss
var SlideOffer_module = __webpack_require__(5957);
var SlideOffer_module_default = /*#__PURE__*/__webpack_require__.n(SlideOffer_module);
;// CONCATENATED MODULE: ./src/modules/professional-services/components/SlideOffer/SlideOffer.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 











const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: {
            max: 4000,
            min: 1200
        },
        items: 3.5
    },
    desktop: {
        breakpoint: {
            max: 1199.99,
            min: 992
        },
        items: 2.5
    },
    tablet: {
        breakpoint: {
            max: 991.99,
            min: 768
        },
        items: 2
    },
    mobile: {
        breakpoint: {
            max: 767.99,
            min: 0
        },
        items: 1.5
    }
};
const getIcon = (index)=>{
    switch(index){
        case 0:
            return discovery.src;
        case 1:
            return iniciatives.src;
        case 2:
            return training.src;
        case 3:
            return adapt.src;
        case 4:
            return managed_services.src;
        default:
            return "";
    }
};
const slide = [
    {
        title: "Discovery",
        desc: "Blockchain has many use cases, and not all are immediately apparent. We will partner with you from day one to understand your IT environment and assess and validate your goals while exploring whether there are additional areas in which blockchain can drive successful outcomes that positively impact your bottom line."
    },
    {
        title: "Aligned Incentives",
        desc: "Our aligned incentive model means we care about your success. Unlike a typical consultancy, we’ll take an active role until your goals are met."
    },
    {
        title: "Training and Education",
        desc: "We provide training to your entire team, from developers to management, which allows you to more efficiently and effectively discover areas where the Casper blockchain can bring additional business value."
    },
    {
        title: "Adapt and Enhance",
        desc: "When we build and design bespoke software for clients, we always keep scalability and upgradability in mind. Even after deployment, features such as smart contracts can be upgraded to scale into evolving business needs."
    },
    {
        title: "Managed Services",
        desc: "Casper Labs provides ongoing, sustained support and maintenance for organizations building on the Casper protocol. We offer both large and small engagement models to fit your individual needs."
    }
];
function SlideOffer() {
    const key = (0,react.useId)();
    const ref = (0,react.useRef)(null);
    const titleClass = "".concat((SlideOffer_module_default()).sectionTitleSlide, " mb-5");
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const carousel = ref.current;
    (0,react.useEffect)(()=>{
        if (carousel) {
            (0,format/* setHorizontalScrollToElement */.x)(carousel.containerRef.current);
        }
    }, [
        carousel
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "slideOffer p-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        lg: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                            className: titleClass,
                            children: [
                                "What we ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-red",
                                    children: "offer"
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (SlideOffer_module_default()).cardsContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_multi_carousel["default"], {
                        ref: ref,
                        responsive: responsive,
                        arrows: false,
                        swipeable: false,
                        draggable: false,
                        children: slide && slide.map((p, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "p-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                    className: "carouselCard" + (" carouselCard" + index),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                                        className: (SlideOffer_module_default()).cardBody,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-flex flex-column justify-content-start h-100",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mb-5",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                        source: getIcon(index)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: "cardTitle mb-4",
                                                            children: p.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Text */.Z.Text, {
                                                            className: "cardContent",
                                                            children: p.desc
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            }, key + index))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "carouselScrollLine"
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(5005);
;// CONCATENATED MODULE: ./src/assets/icons/share-icon-card.svg
/* harmony default export */ var share_icon_card = ({"src":"/_next/static/media/share-icon-card.95cffe2b.svg","height":25,"width":24});
// EXTERNAL MODULE: ./src/modules/professional-services/components/CardsSection/CardsSection.module.scss
var CardsSection_module = __webpack_require__(962);
var CardsSection_module_default = /*#__PURE__*/__webpack_require__.n(CardsSection_module);
;// CONCATENATED MODULE: ./src/modules/professional-services/components/CardsSection/CardsSection.tsx






function CardsSection() {
    const cardClass = "".concat((CardsSection_module_default()).card, " p-3 p-lg-4");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (CardsSection_module_default()).cardsSection,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    className: "mb-lg-0 mb-4",
                    lg: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        target: "_blank",
                        href: "https://docs.casperlabs.io/",
                        className: "text-decoration-none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                            className: cardClass,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "d-flex justify-content-between mb-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "h6",
                                                children: "Documentation"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                source: share_icon_card.src
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-4",
                                        children: "Quick start guides for building or validating on Casper."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: "link text-start",
                                        children: "Read More"
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    lg: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        target: "_blank",
                        href: "https://arxiv.org/pdf/2101.02159.pdf",
                        className: "text-decoration-none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                            className: cardClass,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "d-flex justify-content-between mb-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "h6",
                                                children: "White Paper"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                source: share_icon_card.src
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-4",
                                        children: "The Casper Highway Protocol paper."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: "link text-start",
                                        children: "Get white paper"
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/@shared/components/head/customHead/customHead.tsx
var customHead = __webpack_require__(3065);
// EXTERNAL MODULE: ./src/@shared/components/hero/Hero/Hero.tsx
var Hero = __webpack_require__(4516);
// EXTERNAL MODULE: ./src/@shared/components/newsletter/Newsletter2/Newsletter2.tsx + 1 modules
var Newsletter2 = __webpack_require__(7654);
// EXTERNAL MODULE: ./src/@shared/components/cta/CTARight/CTARight.tsx
var CTARight = __webpack_require__(8395);
// EXTERNAL MODULE: ./src/@shared/components/accordion/Accordion/Accordion.tsx
var Accordion = __webpack_require__(7333);
// EXTERNAL MODULE: ./src/@shared/components/layout/Modal/HotspotModal.tsx
var HotspotModal = __webpack_require__(5039);
// EXTERNAL MODULE: ./src/@shared/hooks/framerMotion.tsx
var framerMotion = __webpack_require__(658);
;// CONCATENATED MODULE: ./src/pages/professional-services/index.tsx















var __N_SSP = true;
function Services() {
    const [showEbookModal, setShowEbookModal] = (0,react.useState)(false);
    const handleClose = ()=>setShowEbookModal(false);
    const heroTitle = 'Customized Software and <span class="text-green">Dedicated Services</span>';
    const accordionTitle = 'Our <span class="text-purple">Engagement</span> Models';
    const AccordionItems = [
        {
            title: "Educate and Engage",
            desc: "Learn the many advantages of the Casper Blockchain and connect these to real business problems."
        },
        {
            title: "Implement and Grow",
            desc: "After integrating new solutions, we help you to scale into new business opportunities."
        },
        {
            title: "Productize",
            desc: "Use proven solutions to create vertical-specific feature deployments at scale."
        }
    ];
    const pageClass = "overflow-hidden servicesPage";
    const isMobile =  true ? window.innerWidth <= 768 : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(customHead/* default */.Z, {
                title: "Hybrid Blockchain Solutions & Services | Casper Labs",
                description: "Unlock blockchain's potential with Casper Labs' professional services. Tap into our unique hybrid blockchain solutions tailored to your business needs.",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preload",
                        href: services_hero.src,
                        as: "image"
                    }),
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preload",
                        href: power_of_blockchain.src,
                        as: "image"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(framerMotion/* default */.Z, {
                animation: "fadeIn",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: pageClass,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                                    isHeader: true,
                                    customClass: "heroServices pt-0 pb-0",
                                    col1: 6,
                                    col2: 6,
                                    halfTitle: "our services",
                                    title: heroTitle,
                                    desc: "Tap into proven software development expertise, innovative design methodologies, and a veteran professional services team. Build on the blockchain that fits directly into your existing technology stack.",
                                    linkButton: {
                                        label: "GET IN TOUCH",
                                        link: "/contact?section=contactForm",
                                        variant: "secondary"
                                    },
                                    bgImage: services_hero.src
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CTARight/* default */.Z, {
                                    col1: 8,
                                    col2: 4,
                                    customClass: "servicesCTA",
                                    halfTitle: "New to blockchain ebook",
                                    title: "Everything you ever wanted to know about Blockchain (but were afraid to ask).",
                                    linkButton: {
                                        label: "Get the ebook",
                                        link: ()=>{
                                            setShowEbookModal(true);
                                        },
                                        variant: "secondary"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                                        y: 300,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockchainEra, {})
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                                    y: 300,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideOffer, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                                        y: 300,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                                            sectionTitle: accordionTitle,
                                            items: AccordionItems
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                                    y: 300,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                                        customClass: "powerBlockchain p-0",
                                        colLg1: 6,
                                        colLg2: 6,
                                        title: "The power of blockchain",
                                        desc: "Learn how Casper Labs is delivering impactful solutions to businesses and organizations worldwide.",
                                        linkButton: {
                                            label: "See our case studies",
                                            link: "/customer-stories",
                                            variant: "primary"
                                        },
                                        bgImage: power_of_blockchain.src
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                                        y: 300,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsSection, {})
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsletter2/* default */.Z, {
                                    col1: 5,
                                    col2: 7,
                                    title: "Sign up for our newsletter!"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HotspotModal/* default */.Z, {
                        formId: "42d4778a-690e-4d4e-b912-1d441d05caea",
                        target: "#ebookForm",
                        showModal: showEbookModal,
                        handleClose: handleClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "ebookForm"
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 6237:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 2113:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ctaRight":"CTARight_ctaRight__aQu0c"};

/***/ }),

/***/ 5380:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"childrenContent":"Hero_childrenContent__hSc1T"};

/***/ }),

/***/ 6025:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"toast":"HotspotModal_toast__TrTg5"};

/***/ }),

/***/ 5973:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"ListLoader_loaderContainer__hS6rF"};

/***/ }),

/***/ 8877:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"newsLetter2":"Newsletter2_newsLetter2__S1IQd","form":"Newsletter2_form____nD9","title":"Newsletter2_title__CRAYf","spinner":"Newsletter2_spinner__LNCxl"};

/***/ }),

/***/ 3253:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"BlockchainEra":"BlockchainEra_BlockchainEra__O14ko","vl":"BlockchainEra_vl__FWgSk","hr":"BlockchainEra_hr__nUPgM","h1":"BlockchainEra_h1__KlWuD"};

/***/ }),

/***/ 962:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"CardsSection_card__n_GeA"};

/***/ }),

/***/ 5957:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sectionTitleSlide":"SlideOffer_sectionTitleSlide__mnnN4","carouselButtonGroup":"SlideOffer_carouselButtonGroup__T_CiU","cardBody":"SlideOffer_cardBody__UuStG","carouselCardExpand":"SlideOffer_carouselCardExpand__Ly2Vq","cardsContainer":"SlideOffer_cardsContainer__s1eu4"};

/***/ }),

/***/ 5607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Accordion; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/uncontrollable/lib/esm/index.js + 4 modules
var esm = __webpack_require__(7150);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(6792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Collapse.js + 1 modules
var Collapse = __webpack_require__(6518);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionContext.js

function isAccordionItemSelected(activeEventKey, eventKey) {
  return Array.isArray(activeEventKey) ? activeEventKey.includes(eventKey) : activeEventKey === eventKey;
}
const context = /*#__PURE__*/react.createContext({});
context.displayName = 'AccordionContext';
/* harmony default export */ var AccordionContext = (context);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionCollapse.js








/**
 * This component accepts all of [`Collapse`'s props](/utilities/transitions/#collapse-props).
 */
const AccordionCollapse = /*#__PURE__*/react.forwardRef(({
  as: Component = 'div',
  bsPrefix,
  className,
  children,
  eventKey,
  ...props
}, ref) => {
  const {
    activeEventKey
  } = (0,react.useContext)(AccordionContext);
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-collapse');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Collapse/* default */.Z, {
    ref: ref,
    in: isAccordionItemSelected(activeEventKey, eventKey),
    ...props,
    className: classnames_default()(className, bsPrefix),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      children: react.Children.only(children)
    })
  });
});
AccordionCollapse.displayName = 'AccordionCollapse';
/* harmony default export */ var esm_AccordionCollapse = (AccordionCollapse);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionItemContext.js

const AccordionItemContext_context = /*#__PURE__*/react.createContext({
  eventKey: ''
});
AccordionItemContext_context.displayName = 'AccordionItemContext';
/* harmony default export */ var AccordionItemContext = (AccordionItemContext_context);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionBody.js







const AccordionBody = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  bsPrefix,
  className,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-body');
  const {
    eventKey
  } = (0,react.useContext)(AccordionItemContext);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_AccordionCollapse, {
    eventKey: eventKey,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, bsPrefix)
    })
  });
});
AccordionBody.displayName = 'AccordionBody';
/* harmony default export */ var esm_AccordionBody = (AccordionBody);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionButton.js







function useAccordionButton(eventKey, onClick) {
  const {
    activeEventKey,
    onSelect,
    alwaysOpen
  } = (0,react.useContext)(AccordionContext);
  return e => {
    /*
      Compare the event key in context with the given event key.
      If they are the same, then collapse the component.
    */
    let eventKeyPassed = eventKey === activeEventKey ? null : eventKey;

    if (alwaysOpen) {
      if (Array.isArray(activeEventKey)) {
        if (activeEventKey.includes(eventKey)) {
          eventKeyPassed = activeEventKey.filter(k => k !== eventKey);
        } else {
          eventKeyPassed = [...activeEventKey, eventKey];
        }
      } else {
        // activeEventKey is undefined.
        eventKeyPassed = [eventKey];
      }
    }

    onSelect == null ? void 0 : onSelect(eventKeyPassed, e);
    onClick == null ? void 0 : onClick(e);
  };
}
const AccordionButton = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'button',
  bsPrefix,
  className,
  onClick,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-button');
  const {
    eventKey
  } = (0,react.useContext)(AccordionItemContext);
  const accordionOnClick = useAccordionButton(eventKey, onClick);
  const {
    activeEventKey
  } = (0,react.useContext)(AccordionContext);

  if (Component === 'button') {
    props.type = 'button';
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    onClick: accordionOnClick,
    ...props,
    "aria-expanded": eventKey === activeEventKey,
    className: classnames_default()(className, bsPrefix, !isAccordionItemSelected(activeEventKey, eventKey) && 'collapsed')
  });
});
AccordionButton.displayName = 'AccordionButton';
/* harmony default export */ var esm_AccordionButton = (AccordionButton);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionHeader.js





const AccordionHeader = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'h2',
  bsPrefix,
  className,
  children,
  onClick,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-header');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, bsPrefix),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_AccordionButton, {
      onClick: onClick,
      children: children
    })
  });
});
AccordionHeader.displayName = 'AccordionHeader';
/* harmony default export */ var esm_AccordionHeader = (AccordionHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionItem.js






const AccordionItem = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  bsPrefix,
  className,
  eventKey,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-item');
  const contextValue = (0,react.useMemo)(() => ({
    eventKey
  }), [eventKey]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionItemContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, bsPrefix)
    })
  });
});
AccordionItem.displayName = 'AccordionItem';
/* harmony default export */ var esm_AccordionItem = (AccordionItem);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Accordion.js












const Accordion = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div',
    activeKey,
    bsPrefix,
    className,
    onSelect,
    flush,
    alwaysOpen,
    ...controlledProps
  } = (0,esm/* useUncontrolled */.Ch)(props, {
    activeKey: 'onSelect'
  });
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion');
  const contextValue = (0,react.useMemo)(() => ({
    activeEventKey: activeKey,
    onSelect,
    alwaysOpen
  }), [activeKey, onSelect, alwaysOpen]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...controlledProps,
      className: classnames_default()(className, prefix, flush && `${prefix}-flush`)
    })
  });
});
Accordion.displayName = 'Accordion';
/* harmony default export */ var esm_Accordion = (Object.assign(Accordion, {
  Button: esm_AccordionButton,
  Collapse: esm_AccordionCollapse,
  Item: esm_AccordionItem,
  Header: esm_AccordionHeader,
  Body: esm_AccordionBody
}));

/***/ }),

/***/ 8182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Card; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(6792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(6611);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/divWithClassName.js
var divWithClassName = __webpack_require__(9602);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardImg.js




const CardImg = /*#__PURE__*/react.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({
  bsPrefix,
  className,
  variant,
  as: Component = 'img',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-img');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(variant ? `${prefix}-${variant}` : prefix, className),
    ...props
  });
});
CardImg.displayName = 'CardImg';
/* harmony default export */ var esm_CardImg = (CardImg);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/CardHeaderContext.js
var CardHeaderContext = __webpack_require__(9059);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardHeader.js






const CardHeader = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-header');
  const contextValue = (0,react.useMemo)(() => ({
    cardHeaderBsPrefix: prefix
  }), [prefix]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardHeaderContext/* default.Provider */.Z.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, prefix)
    })
  });
});
CardHeader.displayName = 'CardHeader';
/* harmony default export */ var esm_CardHeader = (CardHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Card.js








const DivStyledAsH5 = (0,divWithClassName/* default */.Z)('h5');
const DivStyledAsH6 = (0,divWithClassName/* default */.Z)('h6');
const CardBody = (0,createWithBsPrefix/* default */.Z)('card-body');
const CardTitle = (0,createWithBsPrefix/* default */.Z)('card-title', {
  Component: DivStyledAsH5
});
const CardSubtitle = (0,createWithBsPrefix/* default */.Z)('card-subtitle', {
  Component: DivStyledAsH6
});
const CardLink = (0,createWithBsPrefix/* default */.Z)('card-link', {
  Component: 'a'
});
const CardText = (0,createWithBsPrefix/* default */.Z)('card-text', {
  Component: 'p'
});
const CardFooter = (0,createWithBsPrefix/* default */.Z)('card-footer');
const CardImgOverlay = (0,createWithBsPrefix/* default */.Z)('card-img-overlay');
const defaultProps = {
  body: false
};
const Card = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  bg,
  text,
  border,
  body,
  children,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
    children: body ? /*#__PURE__*/(0,jsx_runtime.jsx)(CardBody, {
      children: children
    }) : children
  });
});
Card.displayName = 'Card';
Card.defaultProps = defaultProps;
/* harmony default export */ var esm_Card = (Object.assign(Card, {
  Img: esm_CardImg,
  Title: CardTitle,
  Subtitle: CardSubtitle,
  Body: CardBody,
  Link: CardLink,
  Text: CardText,
  Header: esm_CardHeader,
  Footer: CardFooter,
  ImgOverlay: CardImgOverlay
}));

/***/ }),

/***/ 6212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Modal; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/addEventListener.js
var addEventListener = __webpack_require__(9351);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/canUseDOM.js
var canUseDOM = __webpack_require__(3004);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/ownerDocument.js
var ownerDocument = __webpack_require__(7216);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/removeEventListener.js
var removeEventListener = __webpack_require__(99);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/scrollbarSize.js

var size;
function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (canUseDOM/* default */.Z) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useCallbackRef.js
var useCallbackRef = __webpack_require__(2092);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useEventCallback.js
var useEventCallback = __webpack_require__(8146);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useMergedRefs.js
var useMergedRefs = __webpack_require__(5654);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useWillUnmount.js + 1 modules
var useWillUnmount = __webpack_require__(6852);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/transitionEnd.js + 1 modules
var transitionEnd = __webpack_require__(4305);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/Modal.js + 2 modules
var Modal = __webpack_require__(5288);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/BootstrapModalManager.js + 3 modules
var BootstrapModalManager = __webpack_require__(9673);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Fade.js
var Fade = __webpack_require__(1068);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(6611);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalBody.js

/* harmony default export */ var ModalBody = ((0,createWithBsPrefix/* default */.Z)('modal-body'));
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ModalContext.js
var ModalContext = __webpack_require__(6467);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(6792);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalDialog.js




const ModalDialog = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  contentClassName,
  centered,
  size,
  fullscreen,
  children,
  scrollable,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'modal');
  const dialogClass = `${bsPrefix}-dialog`;
  const fullScreenClass = typeof fullscreen === 'string' ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", { ...props,
    ref: ref,
    className: classnames_default()(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(`${bsPrefix}-content`, contentClassName),
      children: children
    })
  });
});
ModalDialog.displayName = 'ModalDialog';
/* harmony default export */ var esm_ModalDialog = (ModalDialog);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalFooter.js

/* harmony default export */ var ModalFooter = ((0,createWithBsPrefix/* default */.Z)('modal-footer'));
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/AbstractModalHeader.js
var AbstractModalHeader = __webpack_require__(703);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalHeader.js





const defaultProps = {
  closeLabel: 'Close',
  closeButton: false
};
const ModalHeader = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'modal-header');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AbstractModalHeader/* default */.Z, {
    ref: ref,
    ...props,
    className: classnames_default()(className, bsPrefix)
  });
});
ModalHeader.displayName = 'ModalHeader';
ModalHeader.defaultProps = defaultProps;
/* harmony default export */ var esm_ModalHeader = (ModalHeader);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/divWithClassName.js
var divWithClassName = __webpack_require__(9602);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalTitle.js


const DivStyledAsH4 = (0,divWithClassName/* default */.Z)('h4');
/* harmony default export */ var ModalTitle = ((0,createWithBsPrefix/* default */.Z)('modal-title', {
  Component: DivStyledAsH4
}));
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Modal.js
























const Modal_defaultProps = {
  show: false,
  backdrop: true,
  keyboard: true,
  autoFocus: true,
  enforceFocus: true,
  restoreFocus: true,
  animation: true,
  dialogAs: esm_ModalDialog
};
/* eslint-disable no-use-before-define, react/no-multi-comp */

function DialogTransition(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Fade/* default */.Z, { ...props,
    timeout: null
  });
}

function BackdropTransition(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Fade/* default */.Z, { ...props,
    timeout: null
  });
}
/* eslint-enable no-use-before-define */


const Modal_Modal = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  style,
  dialogClassName,
  contentClassName,
  children,
  dialogAs: Dialog,
  'aria-labelledby': ariaLabelledby,
  'aria-describedby': ariaDescribedby,
  'aria-label': ariaLabel,

  /* BaseModal props */
  show,
  animation,
  backdrop,
  keyboard,
  onEscapeKeyDown,
  onShow,
  onHide,
  container,
  autoFocus,
  enforceFocus,
  restoreFocus,
  restoreFocusOptions,
  onEntered,
  onExit,
  onExiting,
  onEnter,
  onEntering,
  onExited,
  backdropClassName,
  manager: propsManager,
  ...props
}, ref) => {
  const [modalStyle, setStyle] = (0,react.useState)({});
  const [animateStaticModal, setAnimateStaticModal] = (0,react.useState)(false);
  const waitingForMouseUpRef = (0,react.useRef)(false);
  const ignoreBackdropClickRef = (0,react.useRef)(false);
  const removeStaticModalAnimationRef = (0,react.useRef)(null);
  const [modal, setModalRef] = (0,useCallbackRef/* default */.Z)();
  const mergedRef = (0,useMergedRefs/* default */.Z)(ref, setModalRef);
  const handleHide = (0,useEventCallback/* default */.Z)(onHide);
  const isRTL = (0,ThemeProvider/* useIsRTL */.SC)();
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'modal');
  const modalContext = (0,react.useMemo)(() => ({
    onHide: handleHide
  }), [handleHide]);

  function getModalManager() {
    if (propsManager) return propsManager;
    return (0,BootstrapModalManager/* getSharedManager */.t)({
      isRTL
    });
  }

  function updateDialogStyle(node) {
    if (!canUseDOM/* default */.Z) return;
    const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
    const modalIsOverflowing = node.scrollHeight > (0,ownerDocument/* default */.Z)(node).documentElement.clientHeight;
    setStyle({
      paddingRight: containerIsOverflowing && !modalIsOverflowing ? scrollbarSize() : undefined,
      paddingLeft: !containerIsOverflowing && modalIsOverflowing ? scrollbarSize() : undefined
    });
  }

  const handleWindowResize = (0,useEventCallback/* default */.Z)(() => {
    if (modal) {
      updateDialogStyle(modal.dialog);
    }
  });
  (0,useWillUnmount/* default */.Z)(() => {
    (0,removeEventListener/* default */.Z)(window, 'resize', handleWindowResize);
    removeStaticModalAnimationRef.current == null ? void 0 : removeStaticModalAnimationRef.current();
  }); // We prevent the modal from closing during a drag by detecting where the
  // the click originates from. If it starts in the modal and then ends outside
  // don't close.

  const handleDialogMouseDown = () => {
    waitingForMouseUpRef.current = true;
  };

  const handleMouseUp = e => {
    if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) {
      ignoreBackdropClickRef.current = true;
    }

    waitingForMouseUpRef.current = false;
  };

  const handleStaticModalAnimation = () => {
    setAnimateStaticModal(true);
    removeStaticModalAnimationRef.current = (0,transitionEnd/* default */.Z)(modal.dialog, () => {
      setAnimateStaticModal(false);
    });
  };

  const handleStaticBackdropClick = e => {
    if (e.target !== e.currentTarget) {
      return;
    }

    handleStaticModalAnimation();
  };

  const handleClick = e => {
    if (backdrop === 'static') {
      handleStaticBackdropClick(e);
      return;
    }

    if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
      ignoreBackdropClickRef.current = false;
      return;
    }

    onHide == null ? void 0 : onHide();
  };

  const handleEscapeKeyDown = e => {
    if (!keyboard && backdrop === 'static') {
      // Call preventDefault to stop modal from closing in restart ui,
      // then play our animation.
      e.preventDefault();
      handleStaticModalAnimation();
    } else if (keyboard && onEscapeKeyDown) {
      onEscapeKeyDown(e);
    }
  };

  const handleEnter = (node, isAppearing) => {
    if (node) {
      updateDialogStyle(node);
    }

    onEnter == null ? void 0 : onEnter(node, isAppearing);
  };

  const handleExit = node => {
    removeStaticModalAnimationRef.current == null ? void 0 : removeStaticModalAnimationRef.current();
    onExit == null ? void 0 : onExit(node);
  };

  const handleEntering = (node, isAppearing) => {
    onEntering == null ? void 0 : onEntering(node, isAppearing); // FIXME: This should work even when animation is disabled.

    (0,addEventListener/* default */.ZP)(window, 'resize', handleWindowResize);
  };

  const handleExited = node => {
    if (node) node.style.display = ''; // RHL removes it sometimes

    onExited == null ? void 0 : onExited(node); // FIXME: This should work even when animation is disabled.

    (0,removeEventListener/* default */.Z)(window, 'resize', handleWindowResize);
  };

  const renderBackdrop = (0,react.useCallback)(backdropProps => /*#__PURE__*/(0,jsx_runtime.jsx)("div", { ...backdropProps,
    className: classnames_default()(`${bsPrefix}-backdrop`, backdropClassName, !animation && 'show')
  }), [animation, backdropClassName, bsPrefix]);
  const baseModalStyle = { ...style,
    ...modalStyle
  }; // If `display` is not set to block, autoFocus inside the modal fails
  // https://github.com/react-bootstrap/react-bootstrap/issues/5102

  baseModalStyle.display = 'block';

  const renderDialog = dialogProps => /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    role: "dialog",
    ...dialogProps,
    style: baseModalStyle,
    className: classnames_default()(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && 'show'),
    onClick: backdrop ? handleClick : undefined,
    onMouseUp: handleMouseUp,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    "aria-describedby": ariaDescribedby,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dialog, { ...props,
      onMouseDown: handleDialogMouseDown,
      className: dialogClassName,
      contentClassName: contentClassName,
      children: children
    })
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ModalContext/* default.Provider */.Z.Provider, {
    value: modalContext,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
      show: show,
      ref: mergedRef,
      backdrop: backdrop,
      container: container,
      keyboard: true // Always set true - see handleEscapeKeyDown
      ,
      autoFocus: autoFocus,
      enforceFocus: enforceFocus,
      restoreFocus: restoreFocus,
      restoreFocusOptions: restoreFocusOptions,
      onEscapeKeyDown: handleEscapeKeyDown,
      onShow: onShow,
      onHide: onHide,
      onEnter: handleEnter,
      onEntering: handleEntering,
      onEntered: onEntered,
      onExit: handleExit,
      onExiting: onExiting,
      onExited: handleExited,
      manager: getModalManager(),
      transition: animation ? DialogTransition : undefined,
      backdropTransition: animation ? BackdropTransition : undefined,
      renderBackdrop: renderBackdrop,
      renderDialog: renderDialog
    })
  });
});
Modal_Modal.displayName = 'Modal';
Modal_Modal.defaultProps = Modal_defaultProps;
/* harmony default export */ var esm_Modal = (Object.assign(Modal_Modal, {
  Body: ModalBody,
  Header: esm_ModalHeader,
  Title: ModalTitle,
  Footer: ModalFooter,
  Dialog: esm_ModalDialog,
  TRANSITION_DURATION: 300,
  BACKDROP_TRANSITION_DURATION: 150
}));

/***/ }),

/***/ 5015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Toast; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useTimeout.js
var useTimeout = __webpack_require__(4044);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 3 modules
var Transition = __webpack_require__(6273);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Fade.js
var Fade = __webpack_require__(1068);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ToastFade.js




const fadeStyles = {
  [Transition/* ENTERING */.d0]: 'showing',
  [Transition/* EXITING */.Ix]: 'showing show'
};
const ToastFade = /*#__PURE__*/react.forwardRef((props, ref) => /*#__PURE__*/(0,jsx_runtime.jsx)(Fade/* default */.Z, { ...props,
  ref: ref,
  transitionClasses: fadeStyles
}));
ToastFade.displayName = 'ToastFade';
/* harmony default export */ var esm_ToastFade = (ToastFade);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useEventCallback.js
var useEventCallback = __webpack_require__(8146);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(6792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/CloseButton.js
var CloseButton = __webpack_require__(1485);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ToastContext.js

const ToastContext = /*#__PURE__*/react.createContext({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClose() {}

});
/* harmony default export */ var esm_ToastContext = (ToastContext);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ToastHeader.js









const defaultProps = {
  closeLabel: 'Close',
  closeButton: true
};
const ToastHeader = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  closeLabel,
  closeVariant,
  closeButton,
  className,
  children,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'toast-header');
  const context = (0,react.useContext)(esm_ToastContext);
  const handleClick = (0,useEventCallback/* default */.Z)(e => {
    context == null ? void 0 : context.onClose == null ? void 0 : context.onClose(e);
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: ref,
    ...props,
    className: classnames_default()(bsPrefix, className),
    children: [children, closeButton && /*#__PURE__*/(0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
      "aria-label": closeLabel,
      variant: closeVariant,
      onClick: handleClick,
      "data-dismiss": "toast"
    })]
  });
});
ToastHeader.displayName = 'ToastHeader';
ToastHeader.defaultProps = defaultProps;
/* harmony default export */ var esm_ToastHeader = (ToastHeader);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(6611);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ToastBody.js

/* harmony default export */ var ToastBody = ((0,createWithBsPrefix/* default */.Z)('toast-body'));
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Toast.js










const Toast = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  transition: Transition = esm_ToastFade,
  show = true,
  animation = true,
  delay = 5000,
  autohide = false,
  onClose,
  bg,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'toast'); // We use refs for these, because we don't want to restart the autohide
  // timer in case these values change.

  const delayRef = (0,react.useRef)(delay);
  const onCloseRef = (0,react.useRef)(onClose);
  (0,react.useEffect)(() => {
    delayRef.current = delay;
    onCloseRef.current = onClose;
  }, [delay, onClose]);
  const autohideTimeout = (0,useTimeout/* default */.Z)();
  const autohideToast = !!(autohide && show);
  const autohideFunc = (0,react.useCallback)(() => {
    if (autohideToast) {
      onCloseRef.current == null ? void 0 : onCloseRef.current();
    }
  }, [autohideToast]);
  (0,react.useEffect)(() => {
    // Only reset timer if show or autohide changes.
    autohideTimeout.set(autohideFunc, delayRef.current);
  }, [autohideTimeout, autohideFunc]);
  const toastContext = (0,react.useMemo)(() => ({
    onClose
  }), [onClose]);
  const hasAnimation = !!(Transition && animation);

  const toast = /*#__PURE__*/(0,jsx_runtime.jsx)("div", { ...props,
    ref: ref,
    className: classnames_default()(bsPrefix, className, bg && `bg-${bg}`, !hasAnimation && (show ? 'show' : 'hide')),
    role: "alert",
    "aria-live": "assertive",
    "aria-atomic": "true"
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_ToastContext.Provider, {
    value: toastContext,
    children: hasAnimation && Transition ? /*#__PURE__*/(0,jsx_runtime.jsx)(Transition, {
      in: show,
      unmountOnExit: true,
      children: toast
    }) : toast
  });
});
Toast.displayName = 'Toast';
/* harmony default export */ var esm_Toast = (Object.assign(Toast, {
  Body: ToastBody,
  Header: esm_ToastHeader
}));

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [437,529,774,888,179], function() { return __webpack_exec__(942); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);